import React from 'react';
import PropTypes from 'prop-types';
import styles from './BrandRefreshButtonSpinner.module.css';

const spinnerSvg = require('./imgs/button-spinner.svg');

/**
 * Brand-refresh Add to Cart / CTA loading spinner.
 * Use inside the CTA while the add-to-cart request is in flight.
 */
const BrandRefreshButtonSpinner = ({ size, className }) => (
  <span
    className={[styles.spinner, className].filter(Boolean).join(' ')}
    style={{ width: size, height: size }}
    data-part="brand-refresh-button-spinner"
    role="status"
    aria-label="Loading"
  >
    <img
      src={spinnerSvg}
      alt=""
      aria-hidden="true"
      className={styles.spinnerImage}
      width={size}
      height={size}
    />
  </span>
);

BrandRefreshButtonSpinner.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

BrandRefreshButtonSpinner.defaultProps = {
  size: 30,
  className: '',
};

export default BrandRefreshButtonSpinner;
